import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-xs-12 col-sm-12 col-md-3 col-lg-2 mt-4 ms-2 ml-4" }
const _hoisted_2 = {
  class: "card mx-3",
  style: {"width":"100%"}
}
const _hoisted_3 = {
  class: "row",
  style: {"padding-top":"10px"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1" }, null, -1)
const _hoisted_5 = { class: "col-md-12 col-lg-3" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "col-md-12 col-lg-7" }
const _hoisted_8 = { style: {"padding-top":"15px"} }
const _hoisted_9 = { id: "fechaC" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = {
  class: "badge bg-dark",
  id: "localidad"
}
const _hoisted_12 = {
  class: "card-body",
  id: "card-body"
}
const _hoisted_13 = { class: "row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1" }, null, -1)
const _hoisted_15 = { class: "col-lg-11" }
const _hoisted_16 = { class: "card-title" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("b", null, "Mensaje:", -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode()
const _hoisted_19 = { id: "problemas" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "col-lg-12",
    style: {"font-align":"center!important"}
  }, [
    /*#__PURE__*/_createElementVNode("h6", {
      class: "card-title",
      style: {"font-size":"12px!important","text-align":"center!important"},
      id: "correo2"
    })
  ])
], -1)
const _hoisted_21 = ["hidden"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("b", null, "Atender", -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["hidden"]
const _hoisted_25 = ["hidden"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            style: {"width":"50px"},
            class: "imgStatus cardimg-top img-responsive hidden-xs hidden-sm",
            src: _ctx.imgStatus(_ctx.device.status),
            alt: "Card image cap"
          }, null, 8, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h6", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, [
              _createTextVNode(_toDisplayString(_ctx.device.date_received), 1),
              _hoisted_10,
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.device.phone_number), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("h6", _hoisted_16, [
              _hoisted_17,
              _hoisted_18,
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.device.text), 1)
            ])
          ])
        ]),
        _hoisted_20,
        _createElementVNode("button", {
          id: "verCompleto",
          class: "btn btn-sm btn-warning btn-block verCompleto",
          hidden: _ctx.device.status!=='unattended',
          "data-bs-container": "body",
          "data-bs-placement": "top",
          "data-trigger": "hover",
          "data-bs-content": "Click para atender",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.asignSMS(_ctx.device.phone_number,_ctx.device.id)))
        }, _hoisted_23, 8, _hoisted_21),
        _createElementVNode("button", {
          id: "verCompleto",
          class: "btn btn-success btn-block verCompleto",
          hidden: _ctx.device.status!=='asigned',
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeSMS(_ctx.device.phone_number,_ctx.device.id)))
        }, " Cerrar ", 8, _hoisted_24),
        _createElementVNode("p", {
          class: "badge bg-danger",
          hidden: _ctx.device.status!=='closed'
        }, " Cerrado ", 8, _hoisted_25)
      ])
    ])
  ]))
}